import React from 'react';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import extendClassName from '../../../lib/bemUtils/bem';

type ChangeNoteProps = {
  note?: string;
  type?: string;
  modifier?: Modifier<'margin-bottom'>;
};

export default function ContentNote({ note, type, modifier }: ChangeNoteProps) {
  if (!note) {
    return null;
  }

  return (
    <p className={extendClassName('content-note', modifier)}>
      {type && <dfn className="invisible">{type}: </dfn>}
      <span className="content-note__text">&bdquo;{note}&ldquo;</span>
    </p>
  );
}
